import { render, staticRenderFns } from "./StorefrontDisabledMessage.vue?vue&type=template&id=12d4738a&"
import script from "./StorefrontDisabledMessage.vue?vue&type=script&lang=js&"
export * from "./StorefrontDisabledMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports